/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeTool} from '../api'

export const useMutationExecuteTool = createReactQueryMutationHook('executeTool', executeTool)
